import { render, staticRenderFns } from "./table-lawyer-court.vue?vue&type=template&id=047a1b39&"
import script from "./table-lawyer-court.vue?vue&type=script&lang=js&"
export * from "./table-lawyer-court.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports